import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="gif" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#e0b148"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#906e24"
          />
        </g>
        <path
          id="Контур_821"
          data-name="Контур 821"
          d="M-1.151-.862a1.508,1.508,0,0,1-.633.387A2.731,2.731,0,0,1-2.7-.327,1.629,1.629,0,0,1-3.919-.795a1.893,1.893,0,0,1-.489-1.3l0-.337a2.322,2.322,0,0,1,.2-1,1.508,1.508,0,0,1,.581-.66,1.644,1.644,0,0,1,.875-.231,1.723,1.723,0,0,1,1.129.333A1.41,1.41,0,0,1-1.153-3h-.9a.738.738,0,0,0-.208-.465.672.672,0,0,0-.454-.139.612.612,0,0,0-.545.3,1.6,1.6,0,0,0-.2.855v.235a1.564,1.564,0,0,0,.2.875.7.7,0,0,0,.627.293.788.788,0,0,0,.545-.163v-.6h-.652v-.644h1.59Zm1.6.481H-.487v-3.89H.448ZM3.605-1.93H2.093v1.55H1.155v-3.89h2.6v.724H2.093v.9H3.605Z"
          transform="translate(574.93 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
